import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'

import * as S from '../styles'

interface SuccessRequestTreatment {
  daysToAuthorizeProcedure: number
}

export const SuccessRequestTreatment = ({ daysToAuthorizeProcedure }): JSX.Element => {
  return (
    <>
      <S.StyledCheckIcon />
      <S.Title>
        Sua consulta com psicólogo foi solicitada!
      </S.Title>
      <S.TextWrapper>
        <Typography variant='content2'>
        Pediremos a autorização para que você possa realizá-la e <b>em até {daysToAuthorizeProcedure} dias úteis</b> você receberá a confirmação por e-mail e sms.
        </Typography>
        <Typography variant='content2'>
          Enquanto você aguarda, ainda não será possível agendar consultas, mas você já pode conhecer nossos psicólogos.
        </Typography>
      </S.TextWrapper>
  </>
  )
}